import axiosInstance from "./api_helper";

export const createSale = async (saleData) => {
  try {
    const response = await axiosInstance.post('/api/sales', {
      items: saleData.items.map(item => ({
        productId: item.id,
        quantity: item.quantity,
        price: item.price
      })),
      totalAmount: saleData.totalAmount
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const closeSale = async (id) => {
  try {
    const response = await axiosInstance.put(`/api/sales/close/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const closeEditedSale = async (id) => {
  try {
    const response = await axiosInstance.put(`/api/sales/edited/close/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const printReceipt = async (id) => {
  return await axiosInstance.get(`/api/sales/bill/${id}`);
};

export const fetchOpenSales = async () => {
  try {
    const response = await axiosInstance.get('/api/sales/open/one');
    return response;
  } catch (error) {
    throw error;
  }
}

export const search = async (filterType, startDate, endDate, query) => {
  try {
    const response = await axiosInstance.get('/api/sales/search', {
      params: {
        filterType,
        startDate,
        endDate,
        query
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSales = async (page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/api/sales', {
      params: { page: page - 1, size }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesData = (dateRange) => axiosInstance.get(`/api/sales/dashboard?dateRange=${dateRange}`);
export const getSalesReport = (dateRange) => axiosInstance.get(`/api/sales/dashboard/report?dateRange=${dateRange}`);
export const getSaleById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/sales/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelSale = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/sales/${id}/cancel`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveItem = async (item) => {
  try {
    const response = await axiosInstance.post('/api/sales/items', item);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveEditedItem = async (item) => {
  try {
    const response = await axiosInstance.post('/api/sales/items/edited', item);
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateItemQuantity = async (id, quantity) => {
  try {
    const response = await axiosInstance.put(`/api/sales/items/${id}?quantity=${quantity}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateEditedItemQuantity = async (id, quantity) => {
  try {
    const response = await axiosInstance.put(`/api/sales/items/edited/${id}?quantity=${quantity}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const updatePrice = async (id, price) => {
  try {
    const response = await axiosInstance.put(`/api/sales/items/price/${id}?price=${price}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateEditedPrice = async (id, price) => {
  try {
    const response = await axiosInstance.put(`/api/sales/items/edited/price/${id}?price=${price}`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const removeItem = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/sales/items/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const removeEditedItem = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/sales/items/edited/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const filterSales = async (filterType, startDate, endDate, query, page, size) => {
  try {
    const response = await axiosInstance.get('/api/sales/items/filter', {
      params: {
        filterType,
        startDate,
        endDate,
        query,
        page,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesByDateRange = async (startDate, endDate, page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/api/sales/search', {
      params: {
        startDate,
        endDate,
        page: page - 1,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalSalesToday = async () => {
  return axiosInstance.get(`/api/sales/total-sales/today`);
};

export const getTotalSalesThisWeek = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-week`);
};

export const getTotalSalesThisMonth = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-month`);
};

export const getTotalSalesThisYear = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-year`);
};

export const getTotalSalesForDateRange = async (startDate, endDate) => {
  return axiosInstance.get(`/api/sales/total-sales`, {
    params: {
      startDate: startDate,
      endDate: endDate
    }
  });
}